module.exports = __webpack_public_path__ + "img/622.That_dirty.04b04a84.svg";